import React from "react";
import MessagingSettings from "./MessagingSettings";
import BaseMessagingSettingsPanel from "ui/component/businesssettings/messaging/BaseMessagingSettingsPanel";
import {useFeatureFlags} from "utilities/featureUtil";

const MessagingSettingsRoute = () => {
  const flags = useFeatureFlags();

  if (flags.twilioWhatsAppImplementation) {
    return <BaseMessagingSettingsPanel />;
  }

  return <MessagingSettings />;
};

export default MessagingSettingsRoute;
